module.exports = __webpack_public_path__ + "e2b560fca1b5bd31f1da2e0339c38c24.png";